/**
 * Featured With Bucket
 * @namespace
 */
__gh__webApp.views.featuredWithBucket = {
	
	"callbacks": function(options){
		var commonJS		= __gh__webApp.common,
			views 			= __gh__webApp.views,
			bucket			= ("bucket" in options) ? options.bucket : {},
			bucket2View		= ("bucket2View" in options) ? options.bucket2View : null;
		
			views.featuredSingle.callbacks();
			
			if (commonJS.isObjectPropertySet(views,bucket2View+".callbacks")){
				views[bucket2View].callbacks(bucket);
			}	
	},
	
	
	"getSubView": function(options){
		var	commonJS				= __gh__webApp.common,
			views					= __gh__webApp.views,
			bucket					= ("bucket" in options) ? options.bucket : {},
			bucket2View				= ("bucket2View" in options) ? options.bucket2View : null,
			staticViewName			= bucket.view.staticName,
			defaultAds				= (commonJS.isObjectPropertySet(views, staticViewName+".defaultAds.noFeaturedSingleBucket")) ? views[staticViewName].defaultAds.noFeaturedSingleBucket : null;
			hasAdSlot6				= commonJS.isObjectPropertySet(bucket, "ads.slot6.view");

	
		// Featured Single Bucket
		var featuredSingleBucket	= JSON.parse(JSON.stringify(bucket)),
			featuredItem			= {
			"main": [featuredSingleBucket.items.main[0]]
		};
		featuredSingleBucket.items 	= featuredItem;
		featuredSingleBucket 		= views.featuredSingle.getSubView(featuredSingleBucket);
	
	
		// Bucket 2
		var bucket2 		= JSON.parse(JSON.stringify(bucket));
			bucket2.title 	= (featuredSingleBucket) ? null : bucket2.title;
			bucket2.heading.title 	= (featuredSingleBucket) ? null : bucket2.heading.title;
	
		if (featuredSingleBucket){
			// remove first item
			bucket2.items.main.shift();
		}
		bucket2 = views[bucket2View].getSubView(bucket2);
	
		
		//Update ads if there is no featured single bucket
		if (!featuredSingleBucket && defaultAds && hasAdSlot6){
			for (var adSlot in defaultAds) {
				bucket.ads[adSlot] = defaultAds[adSlot];
			}
		}
		
		
		//Update main bucket
		bucket.featuredSingleBucket = featuredSingleBucket;
		bucket.bucket2				= bucket2;
		bucket.view.name 			= "buckets/featuredWithBucket/default";
		bucket.items.moreHeadlines	= (commonJS.isObjectPropertySet(bucket2,"items.moreHeadlines")) ? bucket2.items.moreHeadlines : [];
	
		return bucket;
	}
	
};
